import './delete-validation-overlay.scss'

import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import Component from 'vue-class-component';

@Component({
    props: ['message'],
    template: require('./delete-validation-overlay.html')
})
export class DeleteValidationOverlay extends ReactiveVue {

    public message: string;

    private checkIcon = faCheck;
    private crossIcon = faTimes;

    private display = false;

    public onCheckClick() {
        this.$parent.$emit('deletion-validated-topic')
    }

    public onCrossClick() {
        this.$parent.$emit('deletion-canceled-topic')
    }

}